module.exports = __webpack_public_path__ + "img/work1.862a3e2b.gif";